export enum NewPlanStages {
    MODEL = 'model',
    PLAN = 'plan',
    CUSTOMER_DEVICE_DETAILS = 'customer_device_details',
    IMEI = 'imei',
    DOCUMENT_UPLOAD = 'document_upload',
    CUSTOMER_LINK = 'customer_link',
    CONGRATULATION = 'congratulation',
    LEGAL_DOCUMENTS_UPLOAD = 'legal_documents_upload',
    SUMMARY = 'summary',
}

export const popularModels = [
    {
        id: 'find_x2',
        name: 'Find X2',
        image: '/assets/findx2.svg',
    },
    {
        id: 'regno7_pro_5g',
        name: 'Regno7 Pro 5G',
        image: '/assets/findx2.svg',
    },
    {
        id: 'regno6_pro_5g',
        name: 'Regno6 Pro 5G',
        image: '/assets/findx2.svg',
    },
    {
        id: 'f21_pro_5g',
        name: 'F21 Pro 5G',
        image: '/assets/findx2.svg',
    },
];

export enum DeviceCategory {
    MOBILE = 'mobile',
    TABLET = 'tablet',
}

export const policyDetailsInitState = {
    customer: {
        name: '',
        phone: '',
        email: '',
        pincode: '',
    },
    device: {
        id: '',
        name: '',
        type: DeviceCategory.MOBILE,
        serial_number: '',
        purchase_date: '',
        delivery_date: '',
        price: null,
        model_mapping_name: '',
        is_device_verified: false,
        activation_date: '',
        is_device_verified_in_model_page: false,
    },
    document_urls: {},
    document_names: {},
    plan: {
        partner: '',
        plan_id: '',
        plan_name: '',
        purchase_date: '',
        program_id: '',
        premium: null,
        promo_name: '',
        plan_category: '',
    },
    policy_communication: false,
    order_communication: false,
    order_ekey: '',
};
